import { api } from './api';
import type {
  PreloginResponse,
  RegisterRequest,
  LoginRequest,
  LoginResponse,
  RefreshRequest,
  RefreshResponse,
  TwoFactorSetupResponse,
  VerifyEmailResponse,
  ResendVerificationResponse,
} from '@/types/auth';

export const authService = {
  prelogin: (email: string) =>
    api.post<PreloginResponse>('/auth/prelogin', { email }, { skipAuth: true }),

  register: (data: RegisterRequest) =>
    api.post('/auth/register', data, { skipAuth: true }),

  login: (data: LoginRequest) =>
    api.post<LoginResponse>('/auth/login', data, { skipAuth: true }),

  refresh: (data: RefreshRequest) =>
    api.post<RefreshResponse>('/auth/refresh', data, { skipAuth: true }),

  logout: () => api.post('/auth/logout'),

  logoutAll: () => api.post('/auth/logout-all'),

  // 2FA
  setup2FA: () => api.post<TwoFactorSetupResponse>('/auth/2fa/setup'),

  enable2FA: (code: string) => api.post('/auth/2fa/enable', { code }),

  disable2FA: (code: string) => api.post('/auth/2fa/disable', { code }),

  // Password Reset
  forgotPassword: (email: string) =>
    api.post('/auth/forgot-password', { email }, { skipAuth: true }),

  verifyResetCode: (email: string, code: string) =>
    api.post<{ valid: boolean }>('/auth/verify-reset-code', { email, code }, { skipAuth: true }),

  resetPassword: (data: {
    email: string;
    code: string;
    authKeyHash: string;
    salt: string;
    kdfIterations: number;
    kdfMemory: number;
    kdfParallelism: number;
    encryptionKeyVerifier: string;
    defaultVaultNameEncrypted: string;
  }) => api.post('/auth/reset-password', data, { skipAuth: true }),

  // Email Verification
  verifyEmail: (email: string, code: string) =>
    api.post<VerifyEmailResponse>('/auth/verify-email', { email, code }, { skipAuth: true }),

  resendVerification: (email: string) =>
    api.post<ResendVerificationResponse>('/auth/resend-verification', { email }, { skipAuth: true }),
};
